import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const PsuedoStationDepartureTime = ({ isBeforeJourney = false }) =>
  isBeforeJourney ? (
    <FormattedMessage id="journeySummary.validBeforeJourney" />
  ) : (
    <FormattedMessage id="journeySummary.validAfterJourney" />
  );

PsuedoStationDepartureTime.propTypes = {
  isBeforeJourney: PropTypes.bool.isRequired
};

export default PsuedoStationDepartureTime;
